import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Am from '../AM/PropertiesControllerAm.jsx'
import Model from './ModelDo.mjs'

export default function PropertiesPaneDo(props) {
    return (
        <ProductPropertiesPane
            controllers={
                <>
                    <Am />
                    <Text prop="doNo" />
                    <Text prop="doName" />
                    <LongText prop="memo" />
                    <LongText prop="resume" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
